import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Typography } from '@carto/meridian-ds/components'
import { TextField } from '@mui/material'
import ConfirmDialog, { ConfirmDialogResult } from 'features/common/ui/ConfirmDialog/ConfirmDialog'

interface SnowflakeConnectionRoleDialogProps {
  open: boolean
  onConfirm: (role?: string) => void
  onCancel: () => void
  defaultRole?: string
}

function SnowflakeConnectionRoleDialog({ open, onConfirm, onCancel, defaultRole }: SnowflakeConnectionRoleDialogProps) {
  const intl = useIntl()
  const [role, setRole] = useState<string>(defaultRole || '')

  const handleResult = (result: ConfirmDialogResult) => {
    result === ConfirmDialogResult.Confirm ? onConfirm(role) : onCancel()
  }
  return (
    <ConfirmDialog
      open={open}
      title={<FormattedMessage id="connections.create.snowflake.roleDialog.title" />}
      onResult={handleResult}
      confirmLabel={<FormattedMessage id="common.button.continue" />}
      showCancelButton={false}
    >
      <Typography variant="body2" color="textSecondary">
        <FormattedMessage id="connections.create.snowflake.roleDialog.description" />
      </Typography>
      <TextField
        label={intl.formatMessage({ id: 'connections.create.snowflake.form.roleLabel' })}
        value={role}
        onChange={(e) => setRole(e.target.value)}
      />
    </ConfirmDialog>
  )
}

export default SnowflakeConnectionRoleDialog
